import cx from 'classnames'

export const backdropStyles = cx(
  'fixed inset-0 bg-amaze-paperDark/10 dark:bg-black/30',
)
